// src/ui/design-system/typography.ts
//
// 書体方針: UI文言には人間味のあるサンセリフ(判読性重視)、
// センサー計測値・数値だけは等幅数字のモノスペースで「計測データである」ことを
// 視覚的に区別する。これはラベル装飾ではなく、機能上の区別(実測値 vs 案内文)。

export const fontFamily = {
  ui: `"Zen Kaku Gothic New", "Hiragino Sans", "Inter", system-ui, sans-serif`,
  numeric: `"JetBrains Mono", "SF Mono", ui-monospace, monospace`,
} as const;

export const typeScale = {
  display: { size: "2.75rem", lineHeight: 1.05, weight: 700 },
  h1: { size: "1.75rem", lineHeight: 1.2, weight: 700 },
  h2: { size: "1.25rem", lineHeight: 1.3, weight: 600 },
  body: { size: "1rem", lineHeight: 1.6, weight: 400 },
  caption: { size: "0.8125rem", lineHeight: 1.5, weight: 400 },
  // 計測値表示専用(結果カード・Xレイモードの数値カウントアップ)
  readoutLarge: { size: "3rem", lineHeight: 1.0, weight: 600 },
  readoutSmall: { size: "0.9375rem", lineHeight: 1.3, weight: 500 },
} as const;
